module.exports = __webpack_public_path__ + "img/border_bg@3x.0bf6e6fc.png";